"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var polished_1 = require("polished");
var React = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importStar(require("../Themes/styled-components"));
var Loader_1 = require("../Loader");
var MIN_HEIGHT = 16;
var Wrapper = styled_components_1.default('div')(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  overflow: hidden;\n  display: inline-block;\n  max-width: 100%;\n  ", ";\n"], ["\n  overflow: hidden;\n  display: inline-block;\n  max-width: 100%;\n  ",
    ";\n"])), function (_a) {
    var width = _a.width, height = _a.height;
    return styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    width: ", ";\n    height: ", ";\n  "], ["\n    width: ", ";\n    height: ", ";\n  "])), width, height);
});
var Loader = styled_components_1.default(Loader_1.ContentLoader)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  height: 100%;\n  width: 100%;\n  min-height: ", "px;\n  min-width: ", "px;\n"], ["\n  height: 100%;\n  width: 100%;\n  min-height: ", "px;\n  min-width: ", "px;\n"])), MIN_HEIGHT, MIN_HEIGHT);
var NoImage = styled_components_1.default('div')(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  height: 100%;\n  width: 100%;\n  min-height: ", "px;\n  min-width: ", "px;\n  ", "\n\n  &:after,\n  &:before {\n    content: '';\n    position: absolute;\n    transform: rotate(45deg);\n    left: 0;\n    right: 0;\n    height: ", ";\n    top: 50%;\n    background: ", ";\n  }\n\n  &:before {\n    transform: rotate(-45deg);\n  }\n\n  position: relative;\n  vertical-align: middle;\n"], ["\n  height: 100%;\n  width: 100%;\n  min-height: ", "px;\n  min-width: ", "px;\n  ",
    "\n\n  &:after,\n  &:before {\n    content: '';\n    position: absolute;\n    transform: rotate(45deg);\n    left: 0;\n    right: 0;\n    height: ", ";\n    top: 50%;\n    background: ", ";\n  }\n\n  &:before {\n    transform: rotate(-45deg);\n  }\n\n  position: relative;\n  vertical-align: middle;\n"])), MIN_HEIGHT, MIN_HEIGHT, function (_a) {
    var theme = _a.theme;
    return styled_components_1.css(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n    box-shadow: inset 0 0 ", " ", " ", ";\n  "], ["\n    box-shadow: inset 0 0 ", " ", " ", ";\n  "])), polished_1.rem(0), polished_1.rem(2), theme.separatorColor);
}, polished_1.rem(2), function (_a) {
    var theme = _a.theme;
    return theme.separatorColor;
});
var Img = styled_components_1.default.img(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  max-width: 100%;\n"], ["\n  max-width: 100%;\n"])));
var Image = /** @class */ (function (_super) {
    tslib_1.__extends(Image, _super);
    function Image(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isFetching: false,
            error: false,
        };
        _this.imgEl = null;
        _this.init = function (src) {
            if (_this.imgEl) {
                // remove ol' listeners
                _this.imgEl.removeEventListener('load', _this.handleLoad);
                _this.imgEl.removeEventListener('error', _this.handleError);
            }
            if (!src) {
                return;
            }
            if (process.env.NODE_ENV === 'test') {
                _this.setState({ isFetching: false });
            }
            else {
                _this.setState({ isFetching: true });
            }
            if (_this.imgEl) {
                // add new listeners
                _this.imgEl.addEventListener('load', _this.handleLoad);
                _this.imgEl.addEventListener('error', _this.handleError);
                _this.imgEl.src = src;
            }
        };
        _this.handleLoad = function () {
            _this.setState({
                isFetching: false,
                error: false,
            });
        };
        _this.handleError = function () {
            var fallbackSrc = _this.props.fallbackSrc;
            if (_this.imgEl && fallbackSrc && _this.imgEl.src !== fallbackSrc) {
                _this.init(fallbackSrc);
            }
            else {
                _this.setState({
                    isFetching: false,
                    error: true,
                });
            }
        };
        if (typeof document !== 'undefined') {
            _this.imgEl = document.createElement('img');
        }
        return _this;
    }
    Image.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.src !== this.props.src ||
            prevProps.fallbackSrc !== this.props.fallbackSrc) {
            this.init(this.props.src);
        }
    };
    Image.prototype.componentDidMount = function () {
        this.init(this.props.src);
    };
    Image.prototype.componentWillUnmount = function () {
        if (this.imgEl) {
            this.imgEl.removeEventListener('load', this.handleLoad);
            this.imgEl.removeEventListener('error', this.handleError);
        }
    };
    Image.prototype.render = function () {
        var _a = this.props, src = _a.src, alt = _a.alt, height = _a.height, width = _a.width, fallbackSrc = _a.fallbackSrc, restProps = tslib_1.__rest(_a, ["src", "alt", "height", "width", "fallbackSrc"]);
        var _b = this.state, isFetching = _b.isFetching, error = _b.error;
        var heightParsed = height;
        // append units
        if (heightParsed && !Number.isNaN(Number(heightParsed))) {
            heightParsed = heightParsed + "px";
        }
        var widthParsed = width;
        // append units
        if (widthParsed && !Number.isNaN(Number(widthParsed))) {
            widthParsed = widthParsed + "px";
        }
        if (isFetching) {
            return (React.createElement(Wrapper, tslib_1.__assign({ title: alt, height: heightParsed, width: widthParsed }, restProps),
                React.createElement(Loader, null)));
        }
        if (error || (!src && !fallbackSrc)) {
            return (React.createElement(Wrapper, tslib_1.__assign({ title: alt, height: heightParsed, width: widthParsed }, restProps),
                React.createElement(NoImage, null)));
        }
        return (React.createElement(Img, tslib_1.__assign({ alt: alt, src: this.imgEl ? this.imgEl.src : src, height: heightParsed, width: widthParsed }, restProps)));
    };
    return Image;
}(React.Component));
exports.default = Image;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
